module.exports = __webpack_public_path__ + "img/za.b683d459.svg";